import React from 'react';
import ReactMarkdown from 'react-markdown';
import {
    Heading,
    Icon,
    Level,
    Text,
    TextType,
    WithTooltip,
    useTheme,
    InformationIcon,
} from '@defa/defa-component-library';

export interface MarkDownComponentProps {
    children: string; // Ensure children is a string, as expected by react-markdown
}

export function MarkDown({ children }: MarkDownComponentProps) {
    const theme = useTheme();

    // Rename inner "children" to "nodeChildren" to avoid shadowing the outer variable.
    const reactMarkDownComponents: Record<string, React.FC<any>> = {
        h1: ({ children: nodeChildren, ...props }) => (
            <Heading level={Level.h1} {...props}>
                {nodeChildren}
            </Heading>
        ),
        h2: ({ children: nodeChildren, ...props }) => (
            <Heading level={Level.h2} {...props}>
                {nodeChildren}
            </Heading>
        ),
        h3: ({ children: nodeChildren, ...props }) => (
            <Heading level={Level.h3} {...props}>
                {nodeChildren}
            </Heading>
        ),
        h4: ({ children: nodeChildren, ...props }) => (
            <Heading level={Level.h4} {...props}>
                {nodeChildren}
            </Heading>
        ),
        p: ({ children: nodeChildren, ...props }) => (
            <Text type={TextType.body} {...props}>
                {nodeChildren}
            </Text>
        ),
        em: ({ children: nodeChildren, ...props }) => (
            <WithTooltip inline text={`${nodeChildren}`} key="informationTooltip" {...props}>
                <Icon icon={InformationIcon} size={16} key="information" color={theme.textColor} />
            </WithTooltip>
        ),
    };

    return <ReactMarkdown components={reactMarkDownComponents}>{children}</ReactMarkdown>;
}
